<template>
  <footer class="layout-footer">
    <div
      class="ly-container mobile1"
      style="
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        justify-content: space-between;
        margin-left: 9%;
        margin-right: 9%;
      "
    >
      <div class="footer_center" style="margin-bottom: 6vw">
        <img src="@/assets/logo3.png" alt="" class="img1" />
      </div>
      <div class="footer_bottom">
        <div>工作时间：周一至周五 9:00-17:00</div>
        <div>联系电话：(0575) 8512 0001</div>
        <div>官方邮箱：admin@luxun.net</div>
        <div>办公地址：浙江省绍兴市越城区中兴中路276号现代大厦A座10楼</div>
        <div>邮编：312000</div>
      </div>
      <div class="code">
        <img src="@/assets/code.png" alt="" style="width: 120px" />
        <div>微信公众号</div>
      </div>
      <div class="code">
        <img src="@/assets/code2.png" alt="" style="width: 120px" />
        <div>微信订阅号</div>
      </div>
    </div>

    <div class="mobile2">
      <div
        class="ly-container"
        style="
          display: flex;
          align-items: center;
          justify-content: space-evenly;
        "
      >
        <div class="footer_center">
          <img src="@/assets/logo3.png" alt="" class="img1" />
        </div>
        <div>
          <div class="footer_bottom">
            <div>工作时间：周一至周五 9:00-17:00</div>
            <div>联系电话：(0575) 8512 0001</div>
            <div>官方邮箱：admin@luxun.net</div>
            <div>办公地址：浙江省绍兴市越城区中兴中路276号现代大厦A座10楼</div>
            <div>邮编：312000</div>
          </div>
          <div style="
            display: flex;
            justify-content: space-around;
            align-items: center;
            width: 100%;
          ">
            <div class="code">
              <img src="@/assets/code.png" alt="" style="width: 120px" />
              <div>微信公众号</div>
            </div>
            <div class="code">
              <img src="@/assets/code2.png" alt="" style="width: 120px" />
              <div>微信订阅号</div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="bottom">
      <a
        href="https://beian.miit.gov.cn/#/Integrated/index"
        rel="noreferrer"
        target="_blank"
        >鲁迅网的ICP备案编号：浙ICP备2025212709号</a
      >
      <a
        href="https://beian.mps.gov.cn/#/query/webSearch"
        rel="noreferrer"
        target="_blank"
        class="a-center"
      >
        <img src="./icon.png" alt="" />
        浙公网安备33060202001966号</a
      >
      <div>鲁迅基金会版权所有1999-2024</div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "LayoutFooter",
  data() {
    return {
      msg: "Hello Vue!",
    };
  },
};
</script>

<style scoped lang="less">
@media screen and (max-width: 768px) {
  .mobile2 {
    display: flex !important;
  }
  .mobile1 {
    display: none !important;
  }
  .footer_center {
    margin-top: 3rem;
  }
  .layout-footer {
    flex-direction: column !important;
    justify-content: flex-start !important;
    height: 34rem !important;
    .ly-container {
      flex-direction: column !important;
      height: 100%;
      display: flex;
      align-items: center !important;
      justify-content: flex-start !important;
    }
    .bottom {
      margin-top: 29rem ;
      flex-direction: column;
      width: 100%;
    }
  }
}
.mobile2 {
  display: none;
}
.mobile1 {
  display: block;
}
.layout-footer {
  // background-color: var(--primary-color);
  background-image: url("@/assets/images/015.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
  // background-size: contain;
  color: #5b2400;
  display: flex;
  flex-direction: row;
  font-size: 15px;
  justify-content: space-around;
  font-size: 15px;
  height: 300px;
}
.footer_center {
  position: unset;
  left: 10vw;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 2rem;
  .img1 {
    width: 23vw;
    margin-right: 20px;
  }
  .img2 {
    width: 220px;
  }
}
.footer_bottom {
  position: unset;
  left: 39vw;
  > div {
    margin-bottom: 10px;
  }
  .beian span {
    margin: 0 10px;
  }
}
.code {
  position: unset;
  right: 9vw;
  text-align: center;
}
@media screen and (max-width: 768px) {
  .footer_center {
    flex-direction: column;
    .img1 {
      margin-right: 0;
      width: 90%;
    }
    .img2 {
      width: 60%;
    }
  }
  .beian {
    a {
      display: block;
      margin-bottom: 10px;
    }
    .line {
      display: none;
    }
  }
}
.bottom {
  position: absolute;
  margin-top: 250px;
  text-align: center;
  display: flex;
  width: 100%;
  justify-content: space-evenly;
  div {
    margin-bottom: 10px;
  }
}
.a-center {
  display: flex;
  align-items: center;
  img {
    width: 20px;
    margin-right: 5px;
  }
}
</style>
